module.exports = __webpack_public_path__ + "components/rewards/coolbus/static/icon-56f915c5e2e31b072fbe0f484789508e.svg";